import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import BasicLangChip from '../../core/BasicLangChip';
import withGS from '../../core/withGShoc';
import { CONCEPT_LOAD_OPTIONS } from '../../core/utils/constants';

class ConceptChip extends React.Component {

    render() {

        const { data, defaultLang, viewLang, onRemove, onSelect } = this.props;

        const currentId = data.iri && data.iri.length > 0 ?
            data.iri[data.iri.length - 1]
            :
            data.id;

        return (
            <BasicLangChip
                id={currentId}
                deleted={data.pendingDeletion}
                deprecated={data.deprecated}
                onClick={onSelect}
                onDelete={onRemove}
                viewLang={viewLang}
                defaultLang={defaultLang}
                label={data.prefLabel} />
        );
    }
}

ConceptChip.propTypes = {
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    onRemove: PropTypes.func,
    viewLang: PropTypes.string,
    onSelect: PropTypes.func
};

export default withRouter(withGS(ConceptChip, ["ALL"], null, CONCEPT_LOAD_OPTIONS, true));